<template>
  <div>
    <pcHeaders></pcHeaders>

    <div class="cen">
      <div class="w">
        <div class="headBox">
          <div class="leftBox">
            <img v-if=" classInfo.courseImage !== null"
                 :src="classInfo.courseImage"
                 alt="中财专技"
                 :title="classInfo.courseName" />
            <div v-else
                 style="position: relative; display: flex; justify-content: center; align-items: center; width: 320px; height: 256px">
              <img style="position: absolute; top: 0; left: 0; width: 100%; height: 100%"
                   src="../../assets/indexImg/noimg.png"
                   alt="111" />
              <div style="
                  position: relative;
                  z-index: 11;
                  font-size: 15px;
                  font-family: kaiti;
                  text-align: center;
                  padding: 0 10px;
                  font-weight: bold;
                  color: #355fd9;
                ">

                {{ classInfo.courseName }}
              </div>
            </div>
          </div>
          <div class="rightBox">
            <div style="
                font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
                font-weight: bold;
                font-size: 20px;
                color: #333333;
                width: 900px;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
                cursor: pointer;
              ">
              {{ classInfo.courseName }}
            </div>
            <div class="mt10 text_2"
                 style="margin-top: 20px;">
              类型：{{ classInfo.courseCodeName }}
            </div>
            <div class="text_2"
                 style="margin-top: 20px;">总学时: {{ classInfo.courseCredit }}</div>

            <div style="display: flex;margin-top: 103px;">
              <div class="kbtn1" @click="getCourseVideoUrl(courseList[0])">课程试看</div>
              <div class="kbtn2"
                   @click="addUserCourse(classInfo.id)"
                   v-if="classInfo.isBuy == '01'">加入课程名单 </div>
              <div class="kbtn3"
                   v-else>已加入课程名单</div>
            </div>
          </div>
          <div class="hot"
               @click="handleJiti">
            <img style="margin-right: 5px;"
                 src="../../assets/images/zcimg/cicon.png"
                 alt="">
            我的课程名单（{{ myCourseNum }}）
          </div>
        </div>

        <!-- 课程目录 -->
        <div style="width: 1400px;margin: 12px auto;padding: 24px 30px;background: #fff;border-radius: 10px 10px 10px 10px;">
          <div class="kcTitle">
            课程介绍
            <div class="bor">

            </div>
          </div>
          <div class="kcjs">
            {{ classInfo.courseDesc }}
          </div>

          <div class="kcTitle"
               style="margin-top: 40px;">
            教师介绍
            <div class="bor">

            </div>
          </div>
          <div style="color: #000;font-size: 18px;margin-top: 20px;font-weight: bold;">
            {{ classInfo.teacherName }}
          </div>
          <div class="kcjs">

            <div v-html="classInfo.teacherDesc"></div>
          </div>

          <div class="kcTitle"
               style="margin-top: 40px;">
            课程列表
            <div class="bor">
            </div>
          </div>
          <div class="kclist"
               v-if="!falg">
            <div class="k1"> {{ classInfo.courseName }}</div>
            <div class="k2"
                 @click="falg = !falg">合计{{ courseList.length }}章节<img src="../../assets/images/zcimg/left.png"
                   alt=""></div>
          </div>
          <div class="zkList"
               v-else>
            <div class="kcName">
              <div class="k1">{{ classInfo.courseName }}</div>
              <div class="k2"
                   @click="falg = !falg">合计{{ courseList.length }}章节<img src="../../assets/images/zcimg/down.png"
                     alt=""></div>
            </div>

            <div class="kcName"
                 style="margin-top: 16px;"
                 v-for="item in courseList"
                 :key="item.ID">
              <div class="k3">{{ item.CW_NAME }}</div>
              <div class="k4"
                   @click="getCourseVideoUrl(item)">试看</div>
            </div>
          </div>
        </div>

      </div>
    </div>
    <div v-show="showVideoModal"
         class="modal-mask"
         @click="closeModal">
      <!-- 弹窗主体 -->
      <div class="modal-content"
           @click.stop>
        <!-- 关闭按钮 -->
        <button class="close-btn"
                @click="closeModal">×</button>
        <div style="font-size: 17px;margin-bottom: 20px;">正在试看：{{ videoText }}</div>
        <!-- 视频播放器 -->
        <div id="videoPlayer"
             style="width: 100%; height: 100%"
             class="video-js videoBox"
             muted
             @contextmenu.prevent="handleContextMenu"></div>
      </div>
    </div>
    <!-- 我的课程 -->
    <el-dialog title="我的课程名单"
               :visible.sync="dialogVisible"
               width="840px"
               :before-close="handleClose"
               center="">
      <el-table :data="tableData"
                style="width: 100%"
                @selection-change="handleSelectionChange"
                header-row-class-name="my-table-header-row">
        <el-table-column type="selection"
                         width="55"
                         align="center"></el-table-column>
        <el-table-column label="序号"
                         width="80"
                         align="center">
          <template slot-scope="scope">
            {{scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column label="课程名称"
                         align="center">
          <template slot-scope="scope">
            {{ scope.row.courseName }}
          </template>
        </el-table-column>
        <el-table-column label="课程类型"
                         width="120"
                         align="center">
          <template slot-scope="scope">
            {{ scope.row.courseCodeName }}
          </template>
        </el-table-column>
        <el-table-column label="课程学时"
                         width="120"
                         align="center">
          <template slot-scope="scope">
            {{ scope.row.courseCredit }}
          </template>
        </el-table-column>
        <el-table-column label="操作"
                         width="120"
                         align="center">
          <template slot-scope="scope">
            <el-button size="mini"
                       type="danger"
                       @click="removeCourse(scope.row.id)"
                       plain>移除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <div class="pagination-container">
        <pagination background
                    v-show="total1 > 0"
                    :total="total1"
                    :page.sync="courseParams.pageNum"
                    :limit.sync="courseParams.pageSize"
                    @pagination="getTableData" />

      </div>

      <div slot="footer"
           class="dialog-footer">
        <el-button @click="handleBack">返回课程</el-button>
        <el-button type="danger"
                   @click="handleRemove"
                   :disabled="!multipleSelection.length">移除</el-button>
        <el-button type="primary"
                   @click="handleExport">导出到本地</el-button>
      </div>
    </el-dialog>
    <pcBottom></pcBottom>
    <flotRight />
  </div>
</template>
<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
import pcHeaders from '../component/head.vue';
import pcBottom from '../component/bottom.vue';
import { exportUserCourseCw,getUserCourseList, removeUserCourse, getCourseInfo, getCourseVideoUrl, addUserCourse, getUserCourseCount } from '@/api/list.js';
import flotRight from '@/views/component/flotRight.vue';
import courseNav from '@/views/component/courseNav.vue';
import 'xgplayer';
import hlsjsPlayer from 'xgplayer-hls.js';
import Player from 'xgplayer';
export default {
  // import引入的组件需要注入到对象中才能使用
  components: {
    pcHeaders,
    pcBottom,
    flotRight,
    courseNav
  },
  metaInfo() {
    return {
      title: this.title + '中财专技',
      meta: [
        {
          charset: 'utf-8'
        },
        {
          name: 'viewport',
          content: 'width=device-width, initial-scale=1.0,minimum-scale=1.0, maximum-scale=1.0, user-scalable=no'
        }
      ]
    };
  },
  data() {
    // 这里存放数据
    return {
      dialogVisible: false,
      tableData: [],
      total1: 0,
      multipleSelection: [],
      myCourseList: [],
      courseParams: {
        pageNum: 1,
        pageSize: 10
      },
      courseId: '',
      classInfo: {}, //班级数据
      queryParams: {
        pageNum: 1,
        pageSize: 10
      },
      total: 0,
      activeIndex: null,
      recommendEmpty: false,
      imgShow: false,
      priceShow: false,
      isZypx: '', //是否是职业培训
      expandedStates: [], // 用于存储每个课程项的展开状态
      courseList: [], //课程列表
      evaluateList: [], //评价列表
      // dialogVisible: false,
      defaultImageUrl: require('../../assets/images/noimg.png'),
      rule: {}, //考试规则
      title: '',
      falg: false,
      player: null,
      // 控制弹窗显示/隐藏
      showVideoModal: false,
      videoText: '',
      myCourseNum: 0
    };
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
    //获取课程
    handleJiti() {
      this.getTableData();
      this.dialogVisible = true;
    },
    //获取当前用户选课数量
    getUserCourseCount() {
      getUserCourseCount().then(res => {
        this.myCourseNum = res.data.data;
      });
    },
    getTableData() {
      // 模拟接口数据
      getUserCourseList(this.courseParams).then(res => {
        this.tableData = res.data.rows;
        this.total1 = res.data.total;
      });
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage = 1;
      this.getTableData();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getTableData();
    },
    handleBack() {
      this.dialogVisible = false;
      // 可在这里添加返回逻辑
    },
    //删除单个
    removeCourse(id) {
      removeUserCourse({ ids: id }).then(res => {
        console.log(res.data.code);
        if (res.data.code == '200') {
          // 执行移除逻辑
          this.$message.success('移除成功');
          this.getUserCourseCount()
          this.getTableData();
          this.getCourseInfo();
        }
      });
    },
    handleRemove() {
      let ids = [];
      this.multipleSelection.forEach(v => {
        ids.push(v.id);
      });
      this.$confirm('确定要移除选中的课程吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          removeUserCourse({ ids: ids.toString() }).then(res => {
            console.log(res.data.code);
            if (res.data.code == '200') {
              // 执行移除逻辑
              this.$message.success('移除成功');
              this.getUserCourseCount()
              this.getTableData();
              this.getCourseInfo();
            }
          });
        })
        .catch(() => {});
    },
    handleExport() {
      if (this.multipleSelection.length == 0) {
        this.$message.error('请选择需要导出的课程！');
        return false;
      }
      let ids = [];
      this.multipleSelection.forEach(v => {
        ids.push(v.courseId);
      });

      // 改造核心：调用接口时添加响应类型配置，处理二进制流下载
      exportUserCourseCw(
        { ids: ids.toString() },
        {
          // 关键：指定响应类型为blob（二进制文件流）
          responseType: 'blob',
          // 确保能获取响应头（用于解析文件名）
          headers: {
            Accept: 'application/octet-stream'
          }
        }
      )
        .then(res => {
          console.log(res);

          // 1. 创建Blob对象（适配Excel文件，其他类型可调整type）
          const blob = new Blob([res.data], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
          });

          // 2. 解析响应头中的文件名（没有则用默认名）
          let fileName = '课程导出文件.xlsx';
          if (res.headers && res.headers['content-disposition']) {
            const fileNameMatch = res.headers['content-disposition'].match(/filename="?([^"]+)"?/);
            if (fileNameMatch && fileNameMatch[1]) {
              fileName = decodeURIComponent(fileNameMatch[1]);
            }
          }

          // 3. 创建下载链接并触发下载
          const downloadUrl = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = downloadUrl;
          link.download = fileName; // 设置下载文件名
          document.body.appendChild(link);
          link.click(); // 触发下载

          // 4. 清理临时资源
          document.body.removeChild(link);
          window.URL.revokeObjectURL(downloadUrl);

          // 可选：下载成功提示
          this.$message.success('导出成功，文件已开始下载');
        })
        .catch(error => {
          // 异常处理
          console.error('导出失败：', error);
          this.$message.error('导出失败，请稍后重试');
        });
    },
    handleClose() {
      this.dialogVisible = false;
    },
    //加入课程名单
    addUserCourse(id) {
      addUserCourse({ courseId: id }).then(res => {
        console.log(res);
        if (res.data.code == '200') {
          this.$message.success('添加成功');
          this.getUserCourseCount();
          this.getCourseInfo();
        }
      });
    },
    closeModal() {
      this.showVideoModal = false;
      this.player.pause();
    },
    //试听
    getVideo(videoUrl) {
      this.showVideoModal = true;
      if (this.player !== null) {
        this.player.destroy('videoPlayer');
      }
      if (videoUrl.isZjw == '1' || videoUrl.isYlx == '1') {
        this.player = new Player({
          id: 'videoPlayer',
          autoplay: true,
          playsinline: true,
          url: videoUrl.LAUNCH,
          progressDisabled: true
        });
      } else {
        // 判断视频源是否是 m3u8 格式
        if (/\.m3u8$/.test(videoUrl.LAUNCH)) {
          this.player = new hlsjsPlayer({
            id: 'videoPlayer',
            autoplay: true,
            playsinline: true,
            url: videoUrl.LAUNCH,
            progressDisabled: true
          });
        } else {
          let url = videoUrl.LAUNCH + '.mp4';
          this.player = new Player({
            id: 'videoPlayer',
            autoplay: true,
            playsinline: true,
            url: url,
            progressDisabled: true
          });
        }
      }
      let _this = this;
      _this.player.on('loadstart', function () {});
      _this.player.on('progress', function () {});
      _this.player.on('loadedmetadata', function () {});
      _this.player.on('canplaythrough', function () {});
      _this.player.on('waiting', function () {});
      _this.player.on('play', function () {});
      _this.player.on('playing', function () {});
      _this.player.on('pause', function () {});
      _this.player.on('ended', function () {});
      _this.player.on('error', function () {
        console.log('加载错误');
      });
      _this.player.on('seeking', function () {});
      _this.player.on('seeked', function () {});
      _this.player.on('ratechange', function () {});
      _this.player.on('timeupdate', function (e) {
        if (_this.player.currentTime >= 300) {
          _this.$message.error('试听5分钟结束，请购买完整课程进行学习！');
          _this.player.pause();
          _this.player.currentTime = 0;
          return false;
        }
      });
      _this.player.on('volumechange', function () {
        console.log('音量改变');
      });
      _this.player.on('stalled', function () {
        console.log('网速异常');
      });
    },
    getCourseVideoUrl(item) {
      getCourseVideoUrl({ courseId: this.classInfo.id, chapterId: item.ID }).then(res => {
        console.log(res.data.data);
        this.videoText = res.data.data.CW_NAME;
        this.getVideo(res.data.data);
      });
    },
    //跳转试看页面
    watch(item) {
      this.$router.push({
        path: '/courseDetail',
        query: {
          courseId: item
        }
      });
    },
    // 课程展开关闭
    isExpanded(index) {
      return this.expandedStates[index];
    },
    toggleExpand(index) {
      this.$set(this.expandedStates, index, !this.expandedStates[index]);
    },
    getCourseInfo() {
      getCourseInfo({ courseId: this.queryParams.courseId }).then(res => {
        console.log(res.data.data, 'kkk');

        this.classInfo = res.data.data;
        this.title = this.classInfo.courseName;
        if (this.classInfo.chapterList !== null) {
          this.courseList = this.classInfo.chapterList;
        }
        if (this.classInfo.courseImage == '') {
          this.imgShow = true;
        }
      });
    }
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.getUserCourseCount();
    this.queryParams.courseId = this.$route.query.courseId;
    this.getCourseInfo();
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    window.scrollTo({ top: 0 });
  },
  beforeCreate() {}, // 生命周期 - 创建之前
  beforeMount() {} // 生命周期 - 挂载之前
};
</script>
<style lang="less" scoped>
/* //@import url(); 引入公共css类 */
/* 打开弹窗按钮样式 */
::v-deep .el-checkbox__inner {
}
::v-deep .el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
  border-color: #ff9120 !important;
  background-color: #ff9120 !important;
}
::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #ff9120 !important;
}
::v-deep .el-dialog__title {
  color: #333 !important;
  font-weight: bold;
}
::v-deep .my-table-header-row {
  color: #333 !important;
  background: #f4f4f4 !important;
  font-weight: 400 !important;
}
.open-modal-btn {
  padding: 8px 16px;
  background: #409eff;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
}

.open-modal-btn:hover {
  background: #66b1ff;
}

/* 弹窗遮罩层 */
.modal-mask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9;
}

/* 弹窗内容区 */
.modal-content {
  width: 800px;
  background: white;
  border-radius: 8px;
  padding: 20px;
  position: relative;
  #videoPlayer {
    width: 100% !important;
    height: 500px !important;
  }
}

/* 关闭按钮 */
.close-btn {
  position: absolute;
  top: -10px;
  right: -10px;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background: #ff4949;
  color: white;
  border: none;
  cursor: pointer;
  text-align: center;
  line-height: 30px;
  font-size: 26px;
}

.close-btn:hover {
  background: #ff7878;
}

/* 视频播放器样式 */
.video-player {
  width: 100%;
  height: auto;
  border-radius: 4px;
}
.kcTitle {
  position: relative;
  font-weight: bold;
  font-size: 22px;
  color: #333333;
  .bor {
    position: absolute;
    bottom: 2px;
    left: 0;
    width: 87px;
    height: 6px;
    background: linear-gradient(90deg, #217cbe 0%, rgba(33, 124, 190, 0) 100%);
    border-radius: 0px 0px 0px 0px;
  }
}
.kclist {
  margin-top: 18px;
  width: 1340px;
  background: #f2f5f8;
  border-radius: 6px 6px 6px 6px;
  display: flex;
  align-items: center;
  padding: 20px 30px;
  justify-content: space-between;
  cursor: pointer;
  .k1 {
    width: 1000px;
    height: 22px;
    font-weight: 500;
    font-size: 16px;
    color: #444444;
  }
  .k2 {
    display: flex;
    align-items: center;
    height: 20px;
    font-weight: 400;
    font-size: 14px;
    color: #999999;
  }
}
.zkList {
  margin-top: 18px;
  width: 1340px;
  background: rgba(33, 124, 190, 0.1);
  border-radius: 6px 6px 6px 6px;
  padding: 20px 30px;
  .kcName {
    display: flex;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
    .k1 {
      width: 1000px;
      font-weight: 500;
      font-size: 16px;
      color: #444444;
    }
    .k2 {
      display: flex;
      align-items: center;
      font-weight: 400;
      font-size: 14px;
      color: #999999;
    }
    .k3 {
      width: 293px;
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 14px;
      color: #444444;
    }
    .k4 {
      width: 74px;
      height: 30px;
      background: rgba(33, 124, 190, 0.1);
      border-radius: 15px 15px 15px 15px;
      text-align: center;
      line-height: 30px;
      color: #217cbe;
      font-size: 14px;
    }
  }
}
.kcjs {
  margin-top: 18px;
  width: 1340px;
  font-weight: 400;
  font-size: 16px;
  color: #444444;
}
.kbtn1 {
  cursor: pointer;
  width: 120px;
  height: 42px;
  background: #217cbe;
  border-radius: 4px 4px 4px 4px;
  text-align: center;
  line-height: 42px;
  font-weight: 400;
  font-size: 14px;
  color: #ffffff;
  margin-right: 20px;
}
.kbtn2 {
  cursor: pointer;
  width: 120px;
  height: 42px;
  border-radius: 4px 4px 4px 4px;
  text-align: center;
  line-height: 42px;

  border: 1px solid #ffc64c;
  font-weight: 400;
  font-size: 14px;
  color: #ffc64c;
  margin-right: 20px;
}
.kbtn3 {
  cursor: pointer;
  width: 120px;
  height: 42px;
  background: #eaeaea;
  border-radius: 4px 4px 4px 4px;
  text-align: center;
  line-height: 42px;
  font-weight: 400;
  font-size: 14px;
  color: #8b8b8b;
  margin-right: 20px;
}
.title_1 {
  font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
  font-weight: bold;
  font-size: 22px;
  color: #333333;
  width: 100%;
  text-align: center;
}

.title_2 {
  font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
  font-weight: bold;
  font-size: 26px;
  color: rgba(51, 51, 51, 0.05);
}

.cen {
  font-family: Regular;
  display: flex;
  justify-content: center;
  padding-bottom: 100px;
  background: #f6f9fc;

  .w {
    width: 1400px;
    padding-top: 30px;
    background: #f6f9fc;

    .headBox {
      position: relative;
      width: 1400px;
      padding: 30px;
      background: #ffffff;
      box-shadow: 0px 2px 15px 0px rgba(138, 138, 138, 0.08), inset 0px 20px 50px 0px #f0f3f9;
      border-radius: 10px 10px 10px 10px;
      border: 1px solid #ffffff;
      display: flex;

      .leftBox {
        width: 320px;
        height: 256px;
        border-radius: 8px;

        img {
          width: 320px;
          height: 256px;
          border-radius: 8px;
        }
      }

      .rightBox {
        margin-left: 25px;
        font-size: 12px;

        .mt10 {
          margin-top: 10px;
        }

        .text_1 {
          width: 100%;
          display: flex;

          span {
            margin-right: 12px;
            display: inline-block;
            padding: 4px 12px;
            height: 28px;
            line-height: 20px;
            background: rgba(64, 118, 246, 0.1);
            border-radius: 2px 2px 2px 2px;
            font-family: PingFang SC, PingFang SC;
            font-weight: 400;
            font-size: 14px;
            color: #4076f6;
          }
        }

        .text_2 {
          width: 800px;
          height: 20px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          margin-top: 6px;
          cursor: pointer;
          font-family: PingFang SC, PingFang SC;
          font-weight: 400;
          font-size: 14px;
          color: #656e7e;
        }

        .text_3 {
          width: 800px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          margin-top: 12px;
          cursor: pointer;
          font-family: PingFang SC, PingFang SC;
          font-weight: 400;
          font-size: 14px;
          color: #656e7e;
        }

        .box_1 {
          display: flex;
          margin-top: 25px;
          flex-direction: row;
        }

        .goumBtn {
          cursor: pointer;
          cursor: pointer;

          width: 120px;
          height: 42px;
          border-radius: 0px 0px 0px 0px;
          font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
          font-weight: 500;
          font-size: 16px;
          color: #ffffff;
          line-height: 42px;
          text-align: center;
        }
      }

      .hot {
        cursor: pointer;
        position: absolute;
        top: 20px;
        right: 20px;
        height: 46px;
        background: linear-gradient(87deg, #ffc64c 0%, #ff790c 100%);
        box-shadow: 0px 2px 10px 0px rgba(201, 117, 11, 0.4);
        border-radius: 8px 8px 8px 8px;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #ffffff;
        font-size: 16px;
        padding: 0 9px;
      }
    }

    .courseInto {
      padding: 50px 30px 40px 30px;
      margin-top: 20px;
      width: 1400px;
      height: auto;
      background: #ffffff;
      border-radius: 10px 10px 10px 10px;

      .titleBox {
        position: relative;

        .title_2 {
          position: absolute;
          top: 11px;
          left: 39%;
        }
      }
    }
    .contents {
      padding: 50px 30px 40px 30px;
      margin-top: 20px;
      width: 1400px;
      height: auto;
      background: #ffffff;
      border-radius: 10px 10px 10px 10px;

      .titleBox1 {
        position: relative;

        .title_2 {
          position: absolute;
          top: 11px;
          left: 41%;
        }
      }
    }

    .tearchInfo {
      padding: 50px 70px 40px 70px;
      margin-top: 20px;
      width: 1400px;
      height: auto;
      background: #ffffff;
      border-radius: 10px 10px 10px 10px;

      .titleBox2 {
        position: relative;

        .title_2 {
          position: absolute;
          top: 11px;
          left: 37%;
        }
      }
    }

    .analysis {
      padding: 50px 70px 40px 70px;
      margin-top: 20px;
      width: 1400px;
      height: auto;
      background: #ffffff;
      border-radius: 10px 10px 10px 10px;

      .titleBox2 {
        position: relative;

        .title_2 {
          position: absolute;
          top: 11px;
          left: 38%;
        }
      }
    }

    .advantages {
      padding: 50px 185px 40px 185px;
      margin-top: 20px;
      width: 1400px;
      height: auto;
      background: #ffffff;
      border-radius: 10px 10px 10px 10px;

      .titleBox2 {
        position: relative;

        .title_2 {
          position: absolute;
          top: 11px;
          left: 40%;
        }
      }
    }

    .evaluation {
      padding: 50px 59px 46px 50px;
      margin-top: 20px;
      width: 1400px;
      height: auto;
      background: #ffffff;
      border-radius: 10px 10px 10px 10px;

      .titleBox2 {
        position: relative;

        .title_2 {
          position: absolute;
          top: 11px;
          left: 38%;
        }
      }
    }

    .guide {
      padding: 50px;
      margin-top: 20px;
      width: 1400px;
      height: auto;
      background: #ffffff;
      border-radius: 10px 10px 10px 10px;

      .titleBox2 {
        position: relative;

        .title_2 {
          position: absolute;
          top: 11px;
          left: 43%;
        }
      }
    }
  }
}

.text_4 {
  font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
  font-weight: bold;
  font-size: 16px;
  color: #333333;
}

.croBox {
  width: 660px;
  height: auto;

  background: #f6f9fc;
  border-radius: 10px 10px 10px 10px;
  padding: 20px;

  .content1 {
    font-weight: 400;
    font-size: 14px;
    color: #444444;
    line-height: 20px;
    margin-top: 10px;
  }
}

.section_1 {
  margin-top: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  .box_2 {
    width: 280px;
    background: #ffffff;
    box-shadow: 0px 5px 10px 0px rgba(0, 0, 0, 0.05);
    border-radius: 10px 10px 10px 10px;
    border: 1px solid #f3f3f3;
  }

  .text_5 {
    width: 280px;
    height: 48px;
    background: linear-gradient(90deg, #ff8285 0%, #e74f52 100%);
    border-radius: 10px 10px 0px 0px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 14px;
    color: #ffffff;
    line-height: 48px;
    text-align: center;
  }

  .text_6 {
    padding: 16px 20px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    height: 250px;
    height: 250px;
    color: #656e7e;
    line-height: 19px;
  }
}

.tearchInfo {
  .tearch_1 {
    margin-top: 47px;

    .te_info {
      margin-top: 20px;
      width: 865px;
      font-family: PingFang SC, PingFang SC;
      font-weight: 600;
      font-size: 14px;
      color: #444444;
      line-height: 22px;
    }

    background-image: url('https://gcjy-images-cdn.ahsjxjy.com/ahjxjy-v2/prod/ahsjxjy-New-WebApi/2025/04/11/ahsjxjy-New-WebApi_1744354225747.png');
    background-size: 100%;
    background-repeat: no-repeat;
    width: 1260px;
    height: 300px;
    padding: 15px 110px 15px 30px;
    border-radius: 6px 6px 6px 6px;

    .te_name {
      font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
      font-weight: bold;
      font-size: 20px;
      color: #333333;
    }

    .present {
      display: flex;
      margin-top: 12px;

      .present_1 {
        // width: 110px;
        padding: 0 10px;
        height: 30px;
        line-height: 30px;
        text-align: center;
        background: linear-gradient(97deg, #95b5ff 0%, #4093f6 100%);
        border-radius: 15px 15px 15px 15px;
        font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
        font-weight: 400;
        font-size: 14px;
        color: rgba(255, 255, 255, 0.8);
        margin-right: 10px;
      }

      .present_2 {
        width: 110px;
        height: 30px;
        background: linear-gradient(97deg, #95b5ff 0%, #4093f6 100%);
        border-radius: 15px 15px 15px 15px;
        font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
        font-weight: 400;
        font-size: 14px;
        color: rgba(255, 255, 255, 0.8);
        line-height: 30px;
        text-align: center;
      }
    }
  }
}

.buy_1 {
  margin-top: 30px;

  .buy_btn {
    width: 100px;
    height: 32px;
    background: linear-gradient(97deg, #95b5ff 0%, #4093f6 100%);
    border-radius: 19px 19px 19px 19px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: #ffffff;
    line-height: 32px;
    text-align: center;
  }

  .buy_info {
    margin-top: 18px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: #666666;
    line-height: 23px;
  }
}

.student {
  margin-top: 47px;
  width: 1290px;
  border-bottom: 1px solid #f3f3f3;

  .evaluate {
    width: 1300px;
    height: auto;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: #444444;
    line-height: 18px;
    margin-bottom: 24px;
  }

  .avater {
    display: flex;
    margin-bottom: 12px;

    img {
      width: 44px;
      height: 44px;
      border-radius: 44px;
      margin-right: 12px;
    }
  }

  .time_1 {
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: #999999;
  }

  .stu_name {
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 16px;
    color: #333333;

    .phone {
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 12px;
      margin-top: 2px;
      color: #999999;
    }
  }
}

.adva_1 {
  position: relative;
  display: flex;
  width: 500px;

  .adva_2 {
    position: absolute;
    top: -7px;
    left: -80px;
    background-image: url('https://gcjy-images-cdn.ahsjxjy.com/ahjxjy-v2/prod/ahsjxjy-New-WebApi/2025/04/11/ahsjxjy-New-WebApi_1744354389887.png');
    background-size: 100%;
    background-repeat: no-repeat;
    width: 140px;
    height: 66px;
    font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
    font-weight: bold;
    font-size: 16px;
    color: #ffffff;
    line-height: 66px;
    text-align: center;
  }

  .adva_12 {
    position: absolute;
    top: -7px;
    left: -80px;
    background-image: url('https://gcjy-images-cdn.ahsjxjy.com/ahjxjy-v2/prod/ahsjxjy-New-WebApi/2025/04/18/ahsjxjy-New-WebApi_1744966526213.png');
    background-size: 100%;
    background-repeat: no-repeat;
    width: 140px;
    height: 66px;
    font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
    font-weight: bold;
    font-size: 16px;
    color: #ffffff;
    line-height: 66px;
    text-align: center;
  }

  .adva_3 {
    width: 428px;
    height: 58px;
    background: rgba(66, 148, 246, 0.1);
    border-radius: 10px 10px 10px 10px;
    font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
    font-weight: 400;
    font-size: 14px;
    color: #555555;
    line-height: 58px;
    text-align: center;
  }

  .adva_13 {
    width: 428px;
    height: 58px;
    background: rgba(240, 169, 59, 0.1);
    background: rgba(240, 169, 59, 0.1);
    border-radius: 10px 10px 10px 10px;
    font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
    font-weight: 400;
    font-size: 14px;
    color: #555555;
    line-height: 58px;
    padding-left: 64px;
  }
}

.adva_4 {
  position: relative;
  display: flex;
  width: 500px;

  .adva_5 {
    position: absolute;
    top: -7px;
    left: -80px;
    background-image: url('https://gcjy-images-cdn.ahsjxjy.com/ahjxjy-v2/prod/ahsjxjy-New-WebApi/2025/04/11/ahsjxjy-New-WebApi_1744354324068.png');
    background-size: 100%;
    background-repeat: no-repeat;
    width: 140px;
    height: 66px;
    font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
    font-weight: bold;
    font-size: 16px;
    color: #ffffff;
    line-height: 66px;
    text-align: center;
  }

  .adva_6 {
    width: 428px;
    height: 58px;
    background: rgba(248, 132, 65, 0.1);
    background: rgba(248, 132, 65, 0.1);
    border-radius: 10px 10px 10px 10px;
    font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
    font-weight: 400;
    font-size: 14px;
    color: #555555;
    line-height: 58px;
    text-align: center;
  }

  .adva_15 {
    position: absolute;
    top: -7px;
    left: -80px;
    background-image: url('https://gcjy-images-cdn.ahsjxjy.com/ahjxjy-v2/prod/ahsjxjy-New-WebApi/2025/04/18/ahsjxjy-New-WebApi_1744966458782.png');
    background-size: 100%;
    background-repeat: no-repeat;
    width: 140px;
    height: 66px;
    font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
    font-weight: bold;
    font-size: 16px;
    color: #ffffff;
    line-height: 66px;
    text-align: center;
  }

  .adva_16 {
    width: 428px;
    height: 58px;
    background: rgba(86, 187, 147, 0.1);
    background: rgba(86, 187, 147, 0.1);
    border-radius: 10px 10px 10px 10px;
    font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
    font-weight: 400;
    font-size: 14px;
    color: #555555;
    line-height: 58px;
    padding-left: 64px;
  }
}

.adva_7 {
  position: relative;
  display: flex;
  width: 500px;

  .adva_8 {
    position: absolute;
    top: -7px;
    left: -80px;
    background-image: url('https://gcjy-images-cdn.ahsjxjy.com/ahjxjy-v2/prod/ahsjxjy-New-WebApi/2025/04/11/ahsjxjy-New-WebApi_1744354358139.png');
    background-size: 100%;
    background-repeat: no-repeat;
    width: 140px;
    height: 66px;
    font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
    font-weight: bold;
    font-size: 16px;
    color: #ffffff;
    line-height: 66px;
    text-align: center;
  }

  .adva_18 {
    position: absolute;
    top: -7px;
    left: -80px;
    background-image: url('https://gcjy-images-cdn.ahsjxjy.com/ahjxjy-v2/prod/ahsjxjy-New-WebApi/2025/04/18/ahsjxjy-New-WebApi_1744966496183.png');
    background-size: 100%;
    background-repeat: no-repeat;
    width: 140px;
    height: 66px;
    font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
    font-weight: bold;
    font-size: 16px;
    color: #ffffff;
    line-height: 66px;
    text-align: center;
  }

  .adva_9 {
    width: 428px;
    height: 58px;
    background: rgba(234, 87, 89, 0.1);
    background: rgba(234, 87, 89, 0.1);
    border-radius: 10px 10px 10px 10px;
    font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
    font-weight: 400;
    font-size: 14px;
    color: #555555;
    line-height: 58px;
    text-align: center;
  }

  .adva_19 {
    width: 428px;
    height: 58px;
    background: rgba(66, 148, 246, 0.1);
    border-radius: 10px 10px 10px 10px;
    font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
    font-weight: 400;
    font-size: 14px;
    color: #555555;
    line-height: 58px;
    padding-left: 64px;
  }
}

.ana_icon {
  font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
  font-weight: bold;
  font-size: 16px;
  color: #333333;
  display: flex;
  align-items: center;

  img {
    width: 20px;
    height: 20px;
    border-radius: 20px;
    margin-right: 8px;
  }
}

.ana_1 {
  margin-top: 24px;
  width: 400px;
  background: #f2f5f8;
  border-radius: 6px 6px 6px 6px;
  padding: 25px 30px;

  .ana_text {
    margin-top: 11px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: #656e7e;
  }
}

.catalog {
  cursor: pointer;
  display: flex;
  align-items: center;
  padding: 20px 30px;
  justify-content: space-between;
  width: 1340px;
  height: 62px;
  background: #f2f5f8;
  border-radius: 6px 6px 6px 6px;

  .text_10 {
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 16px;
    color: #444444;
  }

  .text_11 {
    display: flex;
    align-items: center;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: #999999;
  }
}

.catalog_1 {
  width: 1340px;
  padding: 20px 30px;
  background: rgba(64, 118, 246, 0.1);
  border-radius: 6px 6px 6px 6px;

  .text_12 {
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 16px;
    color: #4076f6;
  }

  .text_13 {
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: #999999;
    display: flex;
    align-items: center;
  }
}

.chapter {
  margin-top: 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  .chapter_2 {
    width: 74px;
    cursor: pointer;
    height: 30px;
    background: rgba(64, 118, 246, 0.1);
    border-radius: 15px 15px 15px 15px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: #4076f6;
    line-height: 30px;
    text-align: center;
  }

  .text_14 {
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: #444444;
  }

  .text_15 {
    margin-top: 4px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 12px;
    color: #999999;
  }
}
</style>
